/**
 * Formatage des nombres et des montants.
 *
 * Une seule source de vérité : les montants s'affichent partout avec le
 * séparateur de milliers français (espace insécable étroite) et l'unité en
 * capitales — « 1500 mru » devenait illisible dès quatre chiffres.
 */

export const CURRENCY = 'MRU';

const numberFormatter = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 });

/** 1500 -> « 1 500 ». Renvoie « 0 » pour une valeur absente. */
export const formatNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? numberFormatter.format(n) : '0';
};

/** 1500 -> « 1 500 MRU » (pour les chaînes : titres, PDF, notifications). */
export const formatAmount = (value, currency = CURRENCY) => `${formatNumber(value)} ${currency}`;
